module.exports = __webpack_public_path__ + "static/energy_16-fbd1b490b5ab35120ddd400627a178d0.jpg";